export class ReportsUserStateTypes {
    public static readonly GetAccountOverviewByDateRequest = 'getAccountOverviewByDateRequest';
    public static readonly GetAgingSummaryRequest = 'getAgingSummaryRequest';
    public static readonly GetCollectionChecksRequest = 'getCollectionChecksRequest';
    public static readonly GetCreditRequestsRequest = 'getCreditRequestsRequest';
    public static readonly GetFundingsRequest = 'getFundingsRequest';
    public static readonly GetIneligiblesRequest = 'getIneligiblesRequest';
    public static readonly GetPurchasesRequest = 'getPurchasesRequest';
    public static readonly ListInvoiceBatchesRequest = 'listInvoiceBatchesRequest';
    public static readonly SearchChecksRequest = 'searchChecksRequest';
    public static readonly AvailableFundsSummary = 'availableFundsSummary';
}
